export default __webpack_public_path__ + "static/media/Safety Barricade.3ea85428.jpg";